import React from "react";
import { connectSearchBox } from "react-instantsearch-dom";

const SEARCH_DEBOUNCE_MS = 500;
const MIN_QUERY_LENGTH = 2;

const CustomSearchBox = ({
  currentRefinement,
  isSearchStalled,
  refine,
  semiTransparent,
  customReset,
  onChange,
  ...props
}) => {
  const debounceRef = React.useRef(null);
  const inputRef = React.useRef(null);
  const isFocusedRef = React.useRef(false);
  const lastSentQueryRef = React.useRef(currentRefinement || "");

  React.useEffect(() => {
    const nextRefinement = currentRefinement || "";

    if (!isFocusedRef.current && inputRef.current && inputRef.current.value !== nextRefinement) {
      inputRef.current.value = nextRefinement;
    }

    if (nextRefinement === "") {
      lastSentQueryRef.current = "";
    }
  }, [currentRefinement]);

  React.useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  const handleChange = event => {
    const nextValue = event.target.value;

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (nextValue.length < MIN_QUERY_LENGTH) {
      if (lastSentQueryRef.current !== "") {
        lastSentQueryRef.current = "";
        refine("");
      }
    } else {
      debounceRef.current = setTimeout(() => {
        if (lastSentQueryRef.current !== nextValue) {
          lastSentQueryRef.current = nextValue;
          refine(nextValue);
        }
      }, SEARCH_DEBOUNCE_MS);
    }

    if (onChange) {
      onChange(event);
    }
  };

  const handleFocus = () => {
    isFocusedRef.current = true;
  };

  const handleBlur = () => {
    isFocusedRef.current = false;

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
      debounceRef.current = null;
    }

    if (!inputRef.current) {
      return;
    }

    const nextValue = inputRef.current.value;

    if (nextValue.length < MIN_QUERY_LENGTH) {
      if (lastSentQueryRef.current !== "") {
        lastSentQueryRef.current = "";
        refine("");
      }
      return;
    }

    if (lastSentQueryRef.current !== nextValue) {
      lastSentQueryRef.current = nextValue;
      refine(nextValue);
    }
  };

  return (
    <input
      ref={inputRef}
      type="search"
      defaultValue={currentRefinement || ""}
      className="searchInputModal"
      placeholder="Search for something"
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={handleChange}
      {...props}
    />
  );
};

const SearchBox = connectSearchBox(CustomSearchBox);

export default SearchBox;
